export const storageKey = 'storage';
